import { useState, type SyntheticEvent } from "react";
import type {
  DateString,
  ExpenseType,
  TransactionDefaultsDto,
  NewTransactionDto,
} from "../../api/types";
import { makeMoney } from "../../logic/money";

interface UseTransactionFormStateProps {
  defaults: TransactionDefaultsDto;
  createTransaction: {
    mutate: (
      data: NewTransactionDto,
      options?: { onSuccess?: () => void },
    ) => void;
  };
  onSuccess: () => void;
}

export const useTransactionFormState = ({
  defaults,
  createTransaction,
  onSuccess,
}: UseTransactionFormStateProps) => {
  const [datePaid, setDatePaid] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [source, setSource] = useState(defaults.source || "");
  const [merchant, setMerchant] = useState("");
  const [description, setDescription] = useState("");
  const [group, setGroup] = useState(defaults.group || "");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [currency, setCurrency] = useState("");
  const [originalAmount, setOriginalAmount] = useState("");
  const [amount, setAmount] = useState("");
  const [expenseType, setExpenseType] = useState<ExpenseType>(
    defaults.expenseType || "Unknown",
  );
  const [invoice, setInvoice] = useState<string | null>(null);

  const handleSubmit = (e?: SyntheticEvent) => {
    if (e) e.preventDefault();

    const foreignAmount =
      currency && originalAmount ? makeMoney(originalAmount, currency) : null;

    createTransaction.mutate(
      {
        datePaid: datePaid as DateString,
        source,
        merchant,
        description,
        group,
        categories: selectedCategories,
        foreignAmount,
        amount: makeMoney(amount),
        expenseType,
        invoice: invoice as import("../../api/types").InvoiceId | null,
        receiptId: null,
      },
      {
        onSuccess: () => {
          onSuccess();
        },
      },
    );
  };

  return {
    state: {
      datePaid,
      source,
      merchant,
      description,
      group,
      selectedCategories,
      currency,
      originalAmount,
      amount,
      expenseType,
      invoice,
    },
    actions: {
      setDatePaid,
      setSource,
      setMerchant,
      setDescription,
      setGroup,
      setSelectedCategories,
      setCurrency,
      setOriginalAmount,
      setAmount,
      setExpenseType,
      setInvoice,
    },
    computed: {
      isForeignAmountDisabled: !currency,
    },
    handleSubmit,
  };
};
